export const theme = {
  plain: {
    color: 'rgba(233, 237, 237, 1)',
    backgroundColor: '#263238',
  },
  styles: [
    {
      types: ['prolog', 'comment', 'doctype', 'cdata'],
      style: {
        color: '#546e7a',
      },
    },
    {
      types: ['property'],
      style: { color: 'rgba(233, 237, 237, 1)' },
    },
    {
      types: ['tag', 'boolean', 'number', 'constant', 'symbol'],
      style: { color: '#FFCA56' },
    },
    {
      types: ['attr-name', 'char', 'builtin', 'inserted'],
      style: {
        color: '#c792ea',
      },
    },
    {
      types: ['operator', 'entity', 'url', 'variable', 'language-css'],
      style: {
        color: 'hsl(40, 90%, 60%)',
      },
    },
    {
      types: ['deleted'],
      style: {
        color: 'rgb(255, 85, 85)',
      },
    },
    {
      types: ['italic'],
      style: {
        fontStyle: 'italic',
      },
    },
    {
      types: ['important', 'bold'],
      style: {
        fontWeight: 'bold',
      },
    },
    {
      types: ['regex', 'important'],
      style: {
        color: '#e90',
      },
    },
    {
      types: ['atrule', 'attr-value', 'string'],
      style: {
        color: '#c3e88d',
      },
    },
    {
      types: ['punctuation', 'symbol'],
      style: {
        opacity: '0.7',
        color: '#89ddff',
      },
    },
    {
      types: ['keyword'],
      style: { color: '#c792ea' },
    },
    {
      types: ['function'],
      style: { color: '#79A9FF' },
    },
  ],
};
